import { useTranslation } from 'react-i18next';
import { FeedbackContent } from './FeedbackContent';
import styles from './Feedback.module.css';

export type FeedbackProps = {
    turnstileSiteKey: string;
};

/**
 * The inline "block" variant - rendered wherever placed on a page. The footer variant is
 * mounted separately via `renderInFooter`.
 */
export const Feedback = ({ turnstileSiteKey }: FeedbackProps) => {
    const { t } = useTranslation(['feedback']);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h2 className={styles.title}>{t('block.title')}</h2>
                <FeedbackContent source='Block' turnstileSiteKey={turnstileSiteKey} />
            </div>
        </div>
    );
};
